module.exports = __webpack_public_path__ + "static/media/10.35734247.jpg";